export const ADMIN_SETTINGS_RECEIVED = 'ADMIN_SETTINGS_RECEIVED'